var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var getBoxShadow = function (inset) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-shadow: ", " rgba(0, 0, 0, 0.15);\n  "], ["\n    box-shadow: ", " rgba(0, 0, 0, 0.15);\n  "])), inset ? 'inset 0 4px 0' : '0 4px 0 0');
};
var templateObject_1;
//# sourceMappingURL=shared.js.map